import { createFileRoute, redirect, } from '@tanstack/react-router';
import { searchTherapistSearchParamsValidateCoercing, } from '@tymia/main-api';
import { api, } from '../../../api/Api.js';
import { configStore, } from '../../../common/config/ConfigStore.js';
import { reportClientError, } from '../../../error/clientErrorReporter.js';
import {} from '../../../pages/search/SearchTherapist.js';
function validateTherapistSearch(search) {
    // for example, set by ChatGPT or ad campaigns
    delete search.utm_source;
    if (typeof search.postcode === 'string') {
        search.address = search.postcode;
    }
    delete search.postcode;
    const [isValid, params] = searchTherapistSearchParamsValidateCoercing(search);
    if (isValid) {
        return params;
    }
    reportClientError({
        type: 'validation-error',
        name: validateTherapistSearch.name,
        details: {
            search,
            isValid,
            params,
        },
    });
    return {};
}
export const Route = createFileRoute('/search/psychotherapists-in-{-$cityslug}')({
    validateSearch: validateTherapistSearch,
    loaderDeps: ({ search }) => search,
    beforeLoad: ({ search }) => {
        if ('address' in search) {
            throw redirect({
                to: `/search/psychotherapists-in-{-$cityslug}`,
                params: {
                    cityslug: typeof search.address === 'string' ? search.address : '',
                },
                replace: true,
            });
        }
    },
    async loader({ params, deps: search }) {
        const config = configStore.get();
        if (config.state !== 'initialized') {
            throw new Error('Config not initialized');
        }
        // @ts-expect-error
        delete search.postcode;
        return await api.client.therapist.search.request({
            ...search,
            address: params.cityslug,
            locale: config.principal.locale,
        });
    },
});
//# sourceMappingURL=psychotherapists-in-%7B-$cityslug%7D.js.map